import { IReferenceOption, LegalEntityRefDataType, RefDataType } from '@inmarsat-itcloudservices/ui';
import { createSelector } from '@ngrx/store';
import { getAppState } from '..';
import { OtherRefDataType } from './reference-data.reducer';

export const getReferenceDataState = createSelector(getAppState, (state) => state.fullReferenceData);

export const getDataByRefType = (type: RefDataType | OtherRefDataType): any =>
  createSelector(getReferenceDataState, (fullData) => fullData?.[type]);

export const getLoaderByRefType = (type: RefDataType | OtherRefDataType): any =>
  createSelector(getReferenceDataState, (fullData) => fullData?.[`${type}Loader`]);

export const getFullReferenceDataByRefType = (type: RefDataType | OtherRefDataType): any =>
  createSelector(getDataByRefType(type), (data) =>
    data
      ? Object.entries(data).map(
          ([key, item]: [string, any]): IReferenceOption => ({
            item,
            label: item.value,
            value: type === LegalEntityRefDataType.ServiceLevelAgreement ? item.key : key
          })
        )
      : []
  );

export const getFullCreditStatusOptions = getFullReferenceDataByRefType(LegalEntityRefDataType.CreditStatus);

export const getFullCustomerTypeOptions = getFullReferenceDataByRefType(LegalEntityRefDataType.CustomerType);

export const getFullPaymentTermsOptions = getFullReferenceDataByRefType(LegalEntityRefDataType.PaymentTerms);

export const getFullServiceLevelAgreementOptions = getFullReferenceDataByRefType(
  LegalEntityRefDataType.ServiceLevelAgreement
);

export const getFullSiteStatusOptions = getFullReferenceDataByRefType(OtherRefDataType.SiteStatus);

export const getFullAccountGroupOptions = getFullReferenceDataByRefType(OtherRefDataType.AccountGroup);

export const getFullCLEStatusOptions = getFullReferenceDataByRefType(OtherRefDataType.CLEStatus);

export const getFullLegalEntityTypeOptions = getFullReferenceDataByRefType(OtherRefDataType.LegalEntityType);

export const getFullAccountTypeOptions = getFullReferenceDataByRefType(OtherRefDataType.AccountType);

export const getFullSiteTypeOptions = getFullReferenceDataByRefType(OtherRefDataType.SiteType);

export const getFullPersonaTypeOptions = getFullReferenceDataByRefType(OtherRefDataType.PersonaType);

export const getFullDistributionChannelOptions = getFullReferenceDataByRefType(OtherRefDataType.DistributionChannel);
